import React from 'react';
import PropTypes from 'prop-types';
import NarrowEndUserMealCard from '../meal/narrow_end_user_meal_card';

/** Meal or SharedMeal */
const RecipesEndUserMealCard = ({
  mealID,
  parentID,
  title,
  imageUrl,
  isInMealBasket,
  isAddingMealsToBasket,
  onClick,
  favouriteEnabled,
  deleteEnabled,
  onAddToPlanner,
  onAddToMealBasket,
  onRemoveFromMealBasket,
  onDelete,
  afterAddingToFavourites,
  isBackgroundProcessing,
}) => {
  return (
    <NarrowEndUserMealCard
      mealID={mealID}
      parentID={parentID}
      title={title}
      imageUrl={imageUrl}
      onClick={onClick}
      isInMealBasket={isInMealBasket}
      isAddingMealsToBasket={isAddingMealsToBasket}
      favouriteEnabled={favouriteEnabled}
      addToPlannerEnabled
      onAddToPlanner={onAddToPlanner}
      shoppingEnabled
      onAddToMealBasket={onAddToMealBasket}
      onRemoveFromMealBasket={onRemoveFromMealBasket}
      deleteEnabled={deleteEnabled}
      onDelete={onDelete}
      afterAddingToFavourites={afterAddingToFavourites}
      isBackgroundProcessing={isBackgroundProcessing}
    />
  );
};

RecipesEndUserMealCard.propTypes = {
  mealID: PropTypes.string.isRequired,
  parentID: PropTypes.string,
  title: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  isInMealBasket: PropTypes.bool.isRequired,
  isAddingMealsToBasket: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  favouriteEnabled: PropTypes.bool,
  deleteEnabled: PropTypes.bool,
  onAddToPlanner: PropTypes.func.isRequired,
  onAddToMealBasket: PropTypes.func.isRequired,
  onRemoveFromMealBasket: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  afterAddingToFavourites: PropTypes.func,
  isBackgroundProcessing: PropTypes.bool.isRequired,
};

RecipesEndUserMealCard.defaultProps = {
  parentID: null,
  imageUrl: null,
  favouriteEnabled: false,
  deleteEnabled: false,
  afterAddingToFavourites: () => {},
};

export default RecipesEndUserMealCard;
